import React from "react";
import { getExperience } from "../../utils";
import { HiLocationMarker, HiOfficeBuilding, HiAcademicCap } from "react-icons/hi";
import { BsLightningChargeFill } from "react-icons/bs";

const ACHIEVEMENTS = [
  { metric: "35%",    desc: "app performance improvement using React.js, Next.js & TypeScript" },
  { metric: "25%",    desc: "API response time reduction — supporting 5,000+ concurrent users" },
  { metric: "40%",    desc: "faster API responses via Redis caching, reducing server load by 30%" },
  { metric: "60%",    desc: "deployment time cut with Docker & GitHub Actions CI/CD pipelines" },
  { metric: "30%",    desc: "component reuse increase via shared ShadCN + Azure Artifacts library" },
  { metric: "10+",    desc: "junior developers mentored on React architecture & API design" },
  { metric: "120+",   desc: "DSA problems solved on LeetCode" },
];

const INTERESTS = ["Cricket & Badminton", "Tutoring & Mentoring", "Travelling", "Cooking"];

function AboutCard() {
  const experience = getExperience("2022-12-01");

  return (
    <div className="about-card-pro">

      {/* ── Identity block ── */}
      <div className="about-identity">
        <h2 className="about-name">Chandraprakash Kushwaha</h2>
        <p className="about-role">Full Stack Developer &nbsp;·&nbsp; MERN &nbsp;·&nbsp; Next.js &nbsp;·&nbsp; System Design</p>

        <div className="about-meta">
          <span className="about-meta-item">
            <HiLocationMarker className="about-meta-icon" />
            Indore, MP, India
          </span>
          <span className="about-meta-item">
            <HiOfficeBuilding className="about-meta-icon" />
            Bestpeers InfoSystem&nbsp;
            <span className="about-badge">CMMI Level 3</span>
          </span>
          <span className="about-meta-item">
            <HiAcademicCap className="about-meta-icon" />
            B.Tech ECE · RGPV University · 8.02 CGPA
          </span>
        </div>
      </div>

      {/* ── Summary ── */}
      <p className="about-summary">
        Results-driven engineer with{" "}
        <strong className="purple">{experience}+ years</strong> of professional
        experience shipping scalable, production-grade web applications — from
        architecture and API design to cloud deployment and team mentorship.
        Deeply experienced in <strong className="purple">microservices</strong>,{" "}
        real-time systems (<strong className="purple">WebSockets, WebRTC</strong>
        ), and cloud-native infrastructure on{" "}
        <strong className="purple">AWS</strong> &amp;{" "}
        <strong className="purple">Azure DevOps</strong>. Proven track record of
        improving system performance, reducing latency, and leading teams to
        deliver production-grade applications on schedule.
      </p>

      {/* ── Achievements ── */}
      <div className="about-achievements-section">
        <div className="about-section-title">
          <BsLightningChargeFill className="purple" />
          &nbsp; Key Impact
        </div>
        <div className="about-achievements-grid">
          {ACHIEVEMENTS.map(({ metric, desc }) => (
            <div key={metric + desc} className="about-achievement-item">
              <span className="about-metric">{metric}</span>
              <span className="about-metric-desc">{desc}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Interests ── */}
      <div className="about-interests-section">
        <div className="about-section-title">Beyond Code</div>
        <div className="about-interests-tags">
          {INTERESTS.map((item) => (
            <span key={item} className="about-interest-tag">{item}</span>
          ))}
        </div>
      </div>

      {/* ── Quote ── */}
      <blockquote className="about-quote">
        "Strive to build things that make a difference."
      </blockquote>
    </div>
  );
}

export default AboutCard;
